const topbar = {
    docs: 'Belgeler',
    help: 'Yardım',
    subscription: 'Abonelik',
};
export default Object.freeze(topbar);
